import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import produce from "immer"
import { reducerCrud, reducerList, TypeSucesso, TypeErro, reducerListMulti } from 'scorpion-core';

const reducerJsonRelatorio = (state = {}, action) => {

    switch (action.type) {
        case TypeAction.SET_JSON_GERAR:
            return action.payload;
        default:
            return state
    }

}
export default combineReducers({
    jsonGerar: reducerJsonRelatorio,
    rCrudSalvar: reducerCrud(TypeAction.SALVAR),
    rLista: reducerList(TypeAction.LISTAR),
    rListaRelatoriosUser: reducerListMulti([TypeAction.LISTAR_RELATORIOS_USER, TypeAction.LISTAR_RELATORIOS_PUBLICO,]),
})




// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/reducer.js